var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortAmountDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8573 9.89567C25.8573 8.92917 26.6408 8.14567 27.6073 8.14567H50.9406C51.9071 8.14567 52.6906 8.92917 52.6906 9.89567C52.6906 10.8622 51.9071 11.6457 50.9406 11.6457H27.6073C26.6408 11.6457 25.8573 10.8622 25.8573 9.89567Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53649 37.8249C7.21991 37.1415 8.32795 37.1415 9.01136 37.8249L18.3447 47.1582C19.0281 47.8417 19.0281 48.9497 18.3447 49.6331C17.6613 50.3165 16.5532 50.3165 15.8698 49.6331L6.53649 40.2998C5.85307 39.6164 5.85307 38.5083 6.53649 37.8249Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1073 6.979C18.0738 6.979 18.8573 7.76251 18.8573 8.729V48.3957C18.8573 49.3622 18.0738 50.1457 17.1073 50.1457C16.1408 50.1457 15.3573 49.3622 15.3573 48.3957V8.729C15.3573 7.76251 16.1408 6.979 17.1073 6.979Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8573 21.5623C25.8573 20.5958 26.6408 19.8123 27.6073 19.8123H46.2739C47.2404 19.8123 48.0239 20.5958 48.0239 21.5623C48.0239 22.5288 47.2404 23.3123 46.2739 23.3123H27.6073C26.6408 23.3123 25.8573 22.5288 25.8573 21.5623Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8573 33.229C25.8573 32.2625 26.6408 31.479 27.6073 31.479H41.6073C42.5738 31.479 43.3573 32.2625 43.3573 33.229C43.3573 34.1955 42.5738 34.979 41.6073 34.979H27.6073C26.6408 34.979 25.8573 34.1955 25.8573 33.229Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8573 44.8957C25.8573 43.9292 26.6408 43.1457 27.6073 43.1457H36.9406C37.9071 43.1457 38.6906 43.9292 38.6906 44.8957C38.6906 45.8622 37.9071 46.6457 36.9406 46.6457H27.6073C26.6408 46.6457 25.8573 45.8622 25.8573 44.8957Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAmountDown);
export default __webpack_public_path__ + "static/media/sort-amount-down.f6f557f9.svg";
export { ForwardRef as ReactComponent };